import { batch } from 'react-redux'
import { downloadFile, generateBlob } from '@chilecompra/react-kit'

import { makeActionCreator } from '../../config/store/utils'
import { FILTERS_KEYS_DICTIONARY } from '../../config/settings/constants'

import { getDownloadQuoteSearch } from '../../services/quoteSearch'

export const GET_DOWNLOAD_QUOTE_SEARCH_RESULTS = 'GET_DOWNLOAD_QUOTE_SEARCH_RESULTS'
export const GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_ERROR = 'GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_ERROR'
export const GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_SUCCESS = 'GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_SUCCESS'
export const onGetDownloadQuoteSearchResults = makeActionCreator(GET_DOWNLOAD_QUOTE_SEARCH_RESULTS)
export const onGetDownloadQuoteSearchResultsError = makeActionCreator(
  GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_ERROR,
  'payload'
)
export const onGetDownloadQuoteSearchResultsSuccess = makeActionCreator(
  GET_DOWNLOAD_QUOTE_SEARCH_RESULTS_SUCCESS,
  'payload'
)
export const onGetDownloadQuoteSearchResultsThunk = payload => async dispatch => {
  dispatch(onGetDownloadQuoteSearchResults())

  try {
    const filters = Object.fromEntries(payload.query.entries())
    const translatedFilters = Object.keys(filters)
      .filter(key => !(key === 'status' && filters[key] === 'all') && ['now', 'page', 'size'].indexOf(key) === -1)
      .reduce((dictionary, key) => ({ ...dictionary, [FILTERS_KEYS_DICTIONARY[key] || key]: filters[key] }), {})
    const queryString = new URLSearchParams(translatedFilters)

    const { data, headers } = await getDownloadQuoteSearch({
      actionType: GET_DOWNLOAD_QUOTE_SEARCH_RESULTS,
      queryString
    })
    const blob = generateBlob(data, headers['content-type'])

    return batch(() => {
      downloadFile(blob, 'Cotizaciones')
      dispatch(onGetDownloadQuoteSearchResultsSuccess())
    })
  } catch (error) {
    return dispatch(
      onGetDownloadQuoteSearchResultsError({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}
